export const translatedLocalStorageKeys = {
    instantQuoteDefault: 'instantQuoteDefault@translated.com',
    stats: 'stats@translated.com'
};


export const storeInstantQuoteDefault = instantQuoteDefault => window.localStorage.setItem(translatedLocalStorageKeys.instantQuoteDefault, JSON.stringify(instantQuoteDefault));

export const getInstantQuoteDefault = () => {
    try {
        const instantQuoteDefault = window.localStorage.getItem(translatedLocalStorageKeys.instantQuoteDefault);
        if (instantQuoteDefault)
            return JSON.parse(instantQuoteDefault);
    }
    catch (error) {
        console.error('storage.js error', error);
    }
};

export const clearInstantQuoteDefault = () => window.localStorage.removeItem(translatedLocalStorageKeys.instantQuoteDefault);

export const storeStats = stats => window.localStorage.setItem(translatedLocalStorageKeys.stats, JSON.stringify(stats));

export const getStats = () => {
    try {
        const stats = window.localStorage.getItem(translatedLocalStorageKeys.stats);
        if (stats)
            return JSON.parse(stats);
    }
    catch (error) {
        console.error('storage.js error', error);
    }
};

export const clearStats = () => window.localStorage.removeItem(translatedLocalStorageKeys.stats);
